export const DigitsQcFieldName = 'digitsQcFieldComponent';
